import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import * as mobxReact from 'mobx-react';
import * as mobx from 'mobx';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import DefaultButton from '../../../../../global/default-button/default-button';
import { OEToggle } from '../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../global/text/text';
import './sign-in-form.scss';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { ONLY_SPACES_REG_EXP } from '../../../../../../constants/regex.constants';
import { RichTextEditor } from '../../../../../global/rich-text-editor';
import { SignInFormHeader } from './sign-in-form-header/sign-in-form-header';
import SignInFormVM from './sign-in-form.viewmodel';
import { accessCodeHeader, accessCodeInstructions, accessCodeRequestButtonId, accessCodeRequestButtonLabel, accessCodeRequestButtonText, accessCodeRequestedMessage, buttonNavigationOnAccessCodeSignInPageId, buttonNavigationOnAccessCodeSignInPageText, loginErrorMessage, loginInstructions, navigationButtonLabel, requestAccessCodeButtonLabel, signInButtonLabel, signInPageLabel } from './sign-in-form.text';
import { dataIsBeingSavedText, loadingText } from '../../../../../../constants/common-labels.constants';
import { APPLY_AND_CLOSE_TEXT, APPLY_TEXT, CANCEL_TEXT } from '../../../../../../constants/common-labels.constants';
import { REQUEST_ACCESS_CODE_REGISTRATION_APPROVAL_STATUS_TEXT } from '../../../../../../constants/registration-approval.constants';
import { EnablementStatus } from '../../../../../../constants/common.constants';
interface ISignInFormPresentation {
    vm: SignInFormVM;
    intl: IntlShape;
}

// rename to sign in
const SignInFormPresentation = injectIntl(mobxReact.observer(({ vm, intl }: ISignInFormPresentation) => {

    if (vm.isLoading) {
        return <CommonPopupBodyFooterLayout
            body={
                <div className='oe-form meeting-form'>
                    { loadingText() }
                </div>
            }
        />;
    }

    const removeOnlySpacesFromField = mobx.action((value: string, key: string): boolean => {
        if (!value.replace(ONLY_SPACES_REG_EXP, '').length) {
            vm[key] = '';
            return true;
        }
        return false;
    });

    const shouldDisableApplyButton = vm.checkValidity(intl);

    return (
        <CommonPopupBodyFooterLayout
            className={'hidden-scroll'}
            body={
                <>
                    <SignInFormHeader
                        openSignInFormPreview={vm.openSignInFormPreview}
                    />
                    <div className='sign-in-form'>
                        <div className='oe-form'>
                            <FormField
                                label={<FormattedMessage {...signInPageLabel} />}
                            >
                                <input
                                    className='oe-form-field__control'
                                    value={vm.getSignInPageLabel()}
                                    type='text'
                                    onChange={mobx.action(({ target: { value } }) => vm.setSignInPageLabel(value))}
                                    onBlur={mobx.action(({ target: { value } }) => removeOnlySpacesFromField(value, 'header'))}
                                />
                                {vm.getSignInPageLabelError() &&
                                <span className='oe-form-field__error'>{vm.getSignInPageLabelError()}</span>
                                }
                            </FormField>
                            <FormField
                                label={<FormattedMessage {...signInButtonLabel} />}
                            >
                                <input
                                    className='oe-form-field__control'
                                    value={vm.getSignInButtonLabel()}
                                    type='text'
                                    onChange={mobx.action(({ target: { value } }) => vm.setSignInButtonLabel(value))}
                                    onBlur={mobx.action(({ target: { value } }) => removeOnlySpacesFromField(value, 'signInButtonLabel'))}
                                />
                                {vm.getSignInButtonLabelError() &&
                                <span className='oe-form-field__error'>{vm.getSignInButtonLabelError()}</span>
                                }
                            </FormField>
                            <FormField>
                                <RichTextEditor
                                    label={<FormattedMessage {...loginInstructions} />}
                                    value={vm.getLoginInstructions()}
                                    onChange={(event, editor) => vm.setLoginInstructions(editor.getData())}
                                    validationError={vm.getLoginInstructionsError()}
                                />
                            </FormField>
                            <FormField>
                                <RichTextEditor
                                    label={<FormattedMessage {...loginErrorMessage} />}
                                    value={vm.getLoginErrorMessage()}
                                    onChange={(event, editor) => vm.setLoginErrorMessage(editor.getData())}
                                    validationError={vm.getLoginErrorMessageError()}
                                />
                            </FormField>
                            <div className='m-top-15px m-bottom-15px'>
                                <OEToggle
                                    isSelected={vm.isButtonAccessCodeRequestEnabled}
                                    onClick={vm.toggleRequestButtonTextEnabled}
                                />
                                <Text
                                    message={accessCodeRequestButtonText(vm.isButtonAccessCodeRequestEnabled)}
                                    id={accessCodeRequestButtonId(vm.isButtonAccessCodeRequestEnabled)}
                                    description='Label text'
                                />
                                {vm.isButtonAccessCodeRequestEnabled &&
                                    <FormField
                                        label={<FormattedMessage {...accessCodeRequestButtonLabel} />}
                                    >
                                        <input
                                            className='oe-form-field__control'
                                            value={vm.requestButtonText}
                                            type='text'
                                            onChange={mobx.action(({ target: { value } }) => vm.setRequestButtonText(value, intl))}
                                            onBlur={mobx.action(({ target: { value } }) => {
                                                removeOnlySpacesFromField(value, 'requestButtonText');
                                                vm.checkRequestButtonText(vm.requestButtonText, intl);
                                            })}
                                        />
                                        {vm.getRequestButtonTextError() &&
                                            <span className='oe-form-field__error'>{vm.getRequestButtonTextError()}</span>
                                        }
                                    </FormField>
                                }
                            </div>
                            <div className='access-code-form__checkbox-label m-bottom-0px'>
                                <OEToggle
                                    isSelected={vm.requestAccessCodeAutoSingInEnabled}
                                    onClick={vm.toggleRequestAccessCodeAutoSingIn}
                                    isDisabled={false}
                                />
                                <Text
                                    message='One-Step Request Access Code and Sign In'
                                    id='oe.websiteTab.oneStepRequestAccessCode'
                                    description='Label text'
                                />
                            </div>
                            <span className='oe-form-field__info m-bottom-15px'>
                                <FormattedMessage id='oe.websiteTab.oneStepRequestAccessCode.info' />
                            </span>
                            {vm.isAccountRequestAccessCodeRegistrationApprovalEnabled && (
                                <div className='access-code-form__checkbox-label m-bottom-15px'>
                                    <OEToggle
                                        isSelected={vm.requestAccessCodeRegistrationApprovalEnabled}
                                        onClick={vm.toggleRequestAccessCodeRegistrationApproval}
                                        dataTestId='toggle-request-access-code-registration-approval'
                                    />
                                    <Text
                                        {...REQUEST_ACCESS_CODE_REGISTRATION_APPROVAL_STATUS_TEXT}
                                        values={{
                                            suffix: vm.requestAccessCodeRegistrationApprovalEnabled
                                                ? EnablementStatus.ENABLED
                                                : EnablementStatus.DISABLED
                                        }}
                                        className='line-height-25px'
                                    />
                                </div>
                            )}
                            <FormField
                                label={<FormattedMessage {...accessCodeHeader} />}
                            >
                                <input
                                    className='oe-form-field__control'
                                    value={vm.header}
                                    type='text'
                                    onChange={mobx.action(({ target: { value } }) => vm.setHeaderMessage(value))}
                                    onBlur={mobx.action(({ target: { value } }) => removeOnlySpacesFromField(value, 'header'))}
                                />
                                {vm.getHeaderMessageError() &&
                                    <span className='oe-form-field__error'>{vm.getHeaderMessageError()}</span>
                                }
                            </FormField>
                            <FormField
                                label={<FormattedMessage {...requestAccessCodeButtonLabel} />}
                            >
                                <input
                                    className='oe-form-field__control'
                                    value={vm.getRequestAccessCodeButtonLabel()}
                                    type='text'
                                    onChange={mobx.action(({ target: { value } }) => vm.setRequestAccessCodeButtonLabel(value))}
                                    onBlur={mobx.action(({ target: { value } }) => removeOnlySpacesFromField(value, 'requestAccessCodeButtonLabel'))}
                                />
                                {vm.getRequestAccessCodeButtonLabelError() &&
                                <span className='oe-form-field__error'>{vm.getRequestAccessCodeButtonLabelError()}</span>
                                }
                            </FormField>
                            <FormField
                                label={<FormattedMessage {...accessCodeInstructions} />}
                                className='access-code-form__editor'
                            >
                                <RichTextEditor
                                    value={vm.instructions}
                                    onChange={(event, editor) => vm.setInstructionsMessage(editor.getData())}
                                    validationError={vm.getInstructionsMessageError()}
                                />
                            </FormField>
                            <FormField
                                label={<FormattedMessage {...accessCodeRequestedMessage} />}
                                className='access-code-form__editor'
                            >
                                <RichTextEditor
                                    value={vm.requestedMessage}
                                    onChange={(event, editor) => vm.setRequestedMessage(editor.getData())}
                                    validationError={vm.getRequestedMessageError()}
                                />
                            </FormField>
                            <div>
                                <OEToggle
                                    isSelected={vm.isButtonAccessCodeSignInEnabled}
                                    onClick={vm.toggleNavigationButtonTextEnabled}
                                />
                                <Text
                                    message={buttonNavigationOnAccessCodeSignInPageText(vm.isButtonAccessCodeSignInEnabled)}
                                    id={buttonNavigationOnAccessCodeSignInPageId(vm.isButtonAccessCodeSignInEnabled)}
                                    description='Label text'
                                />
                                {vm.isButtonAccessCodeSignInEnabled &&
                                    <FormField
                                        label={<FormattedMessage {...navigationButtonLabel} />}
                                    >
                                        <input
                                            className='oe-form-field__control'
                                            value={vm.navigationButtonText}
                                            type='text'
                                            onChange={mobx.action(({ target: { value } }) => vm.setNavigationButtonText(value, intl))}
                                            onBlur={mobx.action(({ target: { value } }) => {
                                                removeOnlySpacesFromField(value, 'navigationButtonText');
                                                vm.checkNavigationButtonText(vm.navigationButtonText, intl);
                                            })}
                                        />
                                        {vm.getNavigationButtonTextError() &&
                                            <span className='oe-form-field__error'>{vm.getNavigationButtonTextError()}</span>
                                        }
                                    </FormField>
                                }
                            </div>
                        </div>
                    </div>
                </>
            }
            footer={
                <>
                    {vm.isSaving && (
                        <span className='oe-popup-layout__footer-status-area'>
                            { dataIsBeingSavedText() }
                        </span>
                    )}
                    <div className='buttons-block buttons-block--from-right'>
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(APPLY_AND_CLOSE_TEXT)}
                            modifier={['fat', 'confirm-safe']}
                            onClick={() => vm.applySignInForm(intl)}
                            disabled={!shouldDisableApplyButton}
                        />
                        <DefaultButton
                            text={intl.formatMessage(APPLY_TEXT)}
                            modifier={['fat', 'confirm-safe']}
                            onClick={() => vm.applySignInForm(intl)}
                            disabled={!shouldDisableApplyButton}
                        />
                        <DefaultCloseSubWindowButton
                            text={intl.formatMessage(CANCEL_TEXT)}
                        />
                    </div>
                </>
            }
        />
    );
}));


export { SignInFormPresentation };
